import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos

const Seo: React.FC = () => <Head>

  <title>{`Dein Warenkorb bei ${name}`}</title>

  <meta name='description' content={
    `Dein persönlicher Warenkorb bei ${name}. 
    Lege deine Wunschprodukte rein und shoppe so angenehm und schnell.`
  } />

  <link rel='canonical' href={`${url}warenkorb`} />

</Head>

export default Seo
